module.exports = __webpack_public_path__ + "static/images/dotted-line.5a55714e40ffb76e50010cf6905d589e.svg";